import { setMyGoodsList, getMyGoodsList, setMyCollectionList, getMyCollectionList } from '@/utils/storage'
export default {
  namespaced: true,
  state () {
    return {
      // 个人商品列表
      myGoodsList: getMyGoodsList(),
      // 个人收藏列表
      myCollectionList: getMyCollectionList()
    }
  },
  getters: {

  },
  mutations: {
    setMyGoodsList (state, obj) {
      state.myGoodsList = obj
      setMyGoodsList(obj)
    },
    setMyCollectionList (state, obj) {
      state.myCollectionList = obj
      setMyCollectionList(obj)
    }
  },
  actions: {
  }
}
